import { ConfluenceEdition } from '@confluence/session-data';

type UseGetUserCountArgs = {
	edition: ConfluenceEdition | null;
	storageUsage?: number;
};

const FREE_TIER_STORAGE_LIMIT_GB = 2;
const FREE_TIER_RENDER_THRESHOLD_GB = 1;

const STANDARD_TRIAL_STORAGE_LIMIT_GB = 250;
const STANDARD_TRIAL_RENDER_THRESHOLD_GB = 2;

export const useGetStorageUsagePercentage = ({ edition, storageUsage }: UseGetUserCountArgs) => {
	const usageDenominator =
		edition === ConfluenceEdition.FREE
			? FREE_TIER_STORAGE_LIMIT_GB
			: STANDARD_TRIAL_STORAGE_LIMIT_GB;
	const displayThreshold =
		edition === ConfluenceEdition.FREE
			? FREE_TIER_RENDER_THRESHOLD_GB
			: STANDARD_TRIAL_RENDER_THRESHOLD_GB;

	if (!storageUsage || storageUsage <= 0) {
		return { usagePercentage: 0, canRenderStorageUsageBar: false };
	}

	return {
		usagePercentage:
			storageUsage >= usageDenominator ? 100 : Math.floor((storageUsage / usageDenominator) * 100),
		canRenderStorageUsageBar: storageUsage >= displayThreshold,
	};
};
